import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { getSiteConfig, waLink } from "@/lib/api";

export default function WhatsAppFloat() {
  const [number, setNumber] = useState("919876543210");

  useEffect(() => {
    getSiteConfig().then((c) => setNumber(c.whatsapp_number));
  }, []);

  return (
    <a
      data-testid="whatsapp-floating-button"
      href={waLink(number, "Hello Gratiora! I'd like to discuss a gifting requirement.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping [animation-duration:2.5s]" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] transition-transform duration-300 group-hover:scale-110">
        <MessageCircle size={24} />
      </span>
    </a>
  );
}
